import { TextChannels } from '../../../../../../../constants'
import { ASPECT_RATIOS, AspectRatioKey } from 'components/NewFileModal/Types'
import { TextChannelKey, TextGenerationType, TurnInto } from 'types'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import Styles from './ContentTypeCardSwitch.module.scss'
import { ContentType } from 'components/ContentType/ContentType'
import { PressProps } from '@react-aria/interactions'
import { ErrorBoundary } from '@sentry/react'
import { WizardButtonContent } from 'components/Wizards/WizardsV3/WizardButton/WizardButton'
import { PricePill } from 'blaze-ui/Pricing/PricePill/PricePill'
import { useNeedsUpgradeForChannelType } from 'hooks/useChannelNeedsUpgrade'

type Channel =
  | Exclude<TextChannelKey, TurnInto | TextGenerationType>
  | AspectRatioKey
  | GenerationType.Outline
  | GenerationType.ContentBrief
  | GenerationType.InstagramPlanning
  | GenerationType.SEOPlanning
  | GenerationType.TwitterPlanning
  | GenerationType.FacebookPlanning
  | GenerationType.LinkedInPlanning

export interface Props {
  channel: Channel
}

const ContentTypeCardSwitch = ({ channel, ...props }: Props & PressProps) => {
  const { image, name } = { ...TextChannels, ...ASPECT_RATIOS }[channel]

  const { shouldForceUpgrade, nextTierPlan } = useNeedsUpgradeForChannelType()

  return (
    <WizardButtonContent
      {...props}
      key={name}
      image={image}
      title={name}
      badge={
        shouldForceUpgrade(channel as TextChannelKey) && nextTierPlan ? (
          <div className={Styles.upgradeBadge} data-testid="upgrade-badge-container">
            <PricePill plan={nextTierPlan.key} />
          </div>
        ) : undefined
      }
    />
  )
}

const ContentTypeCardSwitchContainer = ({ channel, initialValues }: Props & { initialValues?: object }) => (
  <ErrorBoundary>
    <ContentType type={channel} initialValues={initialValues}>
      <ContentTypeCardSwitch channel={channel} />
    </ContentType>
  </ErrorBoundary>
)

export { ContentTypeCardSwitchContainer as ContentTypeCardSwitch }
